import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlStatus, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileType } from '../../../../store/constants';
import { ActionButtonComponent } from '../../../action-button/action-button.component';
import { ButtonAction } from '../../../action-button/constants';
import { ValidationService } from '../../../../common/services/validation.service';
import { AutoUnsubscribe } from '../../../../common/decorators/auto-unsubscribe.decorator';
import { ProfileReport, ProfileReportNames } from '../../../../store/models';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MonitoringProfileSubscriptionComponent } from '../../profiles/monitoring-profile-subscription/monitoring-profile-subscription.component';
import { MonitoringReportComponent } from '../../report/monitoring-report.component';

@Component({
    selector: 'ui-monitoring-profile-create-dialog',
    templateUrl: './monitoring-profile-create-dialog.component.html',
    styleUrls: ['./monitoring-profile-create-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        TranslateModule,
        ActionButtonComponent,
        MonitoringProfileSubscriptionComponent,
        MonitoringReportComponent,
    ]
})
@AutoUnsubscribe
export class MonitoringProfileCreateDialogComponent implements OnInit {
  @Input() detailsForm: UntypedFormGroup;
  @Input() title: string;
  @Input() dialogRef: MatDialogRef<unknown>;
  @Input() subscriptionForm?: UntypedFormGroup;
  @Input() reportForm?: UntypedFormGroup;
  @Input() report?: ProfileReport;
  @Input() reportItemNameList?: ProfileReportNames[];
  @Input() isDeviationVisible?: boolean;
  @Input() subscriptionTitleTranslationKey = 'monitoring.profile.item.subscription';
  @Input() maxFieldsCount: number;
  @Output() createProfile: EventEmitter<void> = new EventEmitter<void>();
  buttonAction = ButtonAction;
  monitoringProfileType = ProfileType;
  isSubscriptionEnabled: boolean;
  isInvalid$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private subscriptions: Subscription[] = [];

  constructor(public validationService: ValidationService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.detailsForm?.statusChanges?.subscribe((status: FormControlStatus) =>
        this.isInvalid$.next(status === 'INVALID'),
      ),
    );
  }
}
